
const SolMezclasGameSoon = () => {
  return (
    <div className="button-home">
      <img src={`${AZURE_BASE_URL}/button-game-soon.webp`} className='w-full' />
    </div>
  )
}

export default SolMezclasGameSoon

